<template>
  <div style="overflow: hidden;"
       :style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">

    <el-card shadow="false" class="box-card" v-for="groupItem in menus" :key="groupItem.title"
             style="margin-bottom: 40px">
      <!--        <div style="margin-left: 40px; font-size: 16px; margin-bottom: 10px; margin-top: 60px; ">{{-->
      <!--            groupItem.title-->
      <!--          }}-->
      <!--        </div>-->
      <div slot="header" class="clearfix">
        <div style="font-size: 18px">{{ groupItem.title }}</div>
      </div>
      <div class="flex-container">
        <div class="flex-item" v-for="item in groupItem.agents" @click="click(item)">
          <img style="border-radius: 20px" :src="item.avatar" width="60%">
          <div style="text-align: center;margin-top: 10px; font-size: 16px">{{ item.title }}</div>
        </div>
      </div>
    </el-card>

    <voice-chat ref="voiceChat"></voice-chat>
  </div>
</template>

<script>
import VoiceChat from '../../pages/aigc/voice_chat_dialog_custom'

export default {
  name: 'SystemMenu',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      menus: [],
    }
  },

  mounted() {
    //if (this.$platform === 1) {
      this.getMenuList()
    //}
  },
  components: {
    VoiceChat
  },

  methods: {
    getMenuList: function () {
      let t = this;
      this.$get(
          {
            context: t,
            path: '/function/menu/list/',
            params: {},
            success: function (data) {
              t.menus = data;
            }
          }
      )
    },

    click(item) {
      if (item.type === 100) {
        this.$router.push(item.page);
      } else {
        if (item.chatMode === 1 || item.chatMode === 2) {
          this.$router.push('/app/agent_use?item_id=' + item.itemId + "&title=" + item.title)
        } else if (item.chatMode === 20 || item.chatMode === 22) {
          this.$refs.voiceChat.show(item.itemId, item.title);
        } else {
          this.$message('暂不支持使用')
        }
      }
    }

  }
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-wrap: wrap; /* 关键属性：允许自动换行 */
  gap: 10px; /* 可选：设置项目之间的间距 */
}

.flex-item {
  flex: 1 1 auto; /* 项目可以伸缩 */
  min-width: 150px; /* 设置最小宽度，防止项目过小 */
  max-width: 150px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}
</style>